export default __webpack_public_path__ + "static/media/bottom-bar-chat.ca94b34b.svg";